import store from './store'
import {createApp} from 'vue'

//pull all vue components out of the root template <noscript> tag
let parser = new DOMParser();
let rootTemplate = document.querySelector("#root-template");
let rootTemplateHtml = parser.parseFromString(rootTemplate.innerHTML, 'text/html');

rootTemplateHtml.querySelectorAll(".js-vue-component").forEach((component) => {
  document.querySelector("#vue-components").appendChild(component);
});

rootTemplate.innerHTML = rootTemplateHtml.querySelector('body').innerHTML;

//change the root template noscript tag to a script tag
let rootTemplateScript = document.createElement("script");
rootTemplateScript.innerHTML = rootTemplate.innerHTML;
rootTemplateScript.setAttribute("id", rootTemplate.getAttribute("id"));
rootTemplateScript.setAttribute("type", rootTemplate.getAttribute("type"));

rootTemplate.parentNode.replaceChild(rootTemplateScript, rootTemplate);

//initialize Vue app
const app = createApp({
  template: '#root-template',
  store: store
});
app.config.errorHandler = function (err, vm, info) {
  try {
    console.error(`Vue Error: ${vm.$options.name || vm.$options.template}`, info, err)
  } catch (e) {
    console.error("VueError -> Console Error", e)
  }
  window.onerror(info, vm.$options.name || vm.$options.template, null, null, err)
}
app.use(store);
export {app as default};